<template>
  <section>
    <div
      v-if="dataTable.length > 0"
      class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2"
    >
      <div
        class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white"
      >
        <DropDownOptions
          v-model="selectedFilter"
          :label="'TIPOS'"
          :options="['TODOS', ...filters]"
        />

        <SearchInput v-model="searchTerm" />
      </div>

      <DataTable :data="filteredData" @delete="deleteDocument($event)">
        <template #head>
          <th scope="col" class="px-6 py-3">Tipo</th>
          <th scope="col" class="px-6 py-3">Motivo</th>
          <th scope="col" class="px-6 py-3">Realizado em</th>
          <th scope="col" class="px-6 py-3 text-center">#</th>
        </template>
      </DataTable>
    </div>

    <NoDataAnim v-else :label="'Não há manutenções cadastradas'" />
  </section>
</template>

<script setup>
import DropDownOptions from "@/components/Tables/DropDownOptions.vue";
import SearchInput from "@/components/Tables/SearchInput.vue";
import DataTable from "./DataTable.vue";
import AsosService from "../../service/extinguisher.service";
import NoDataAnim from "@/components/Lotties/NoDataAnim.vue";
import moment from "moment";
import { showToast as toast } from "@/helpers/UseToasts";
import { computed, onMounted, ref } from "vue";
import { dataExtinguisher } from "../../store";
import { initFlowbite } from "flowbite";
import { storeApp } from "@/store";

import ExtinguisherService from "../../service/extinguisher.service";

const store = dataExtinguisher;
const searchTerm = ref("");
const selectedFilter = ref("");

const props = defineProps({
  dataTable: [Object, Array],
});

const filters = [...new Set(props.dataTable?.map((i) => i.type))];

const dataTable = computed(() => {
  return props.dataTable?.map((row) => {
    const valueData = row.value ? JSON.parse(row.value) : {};
    const carried_out_in = formatDate(row.carried_out_in);

    return {
      ...row,
      ...valueData[0],
      carried_out_in,
    };
  });
});

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase();

  return dataTable?.value?.filter((row) => {
    if (selectedFilter.value == "TODOS") {
      selectedFilter.value = "";
    }

    const matchesDropdown =
      !selectedFilter.value || row.type === selectedFilter.value;

    const matchesSearch =
      !searchTerm.value ||
      ["type", "description", "motivo", "carried_out_in"].some(
        (key) =>
          row[key] &&
          row[key].toString().toLowerCase().includes(searchTermLower)
      );

    return matchesDropdown && matchesSearch;
  });
});

function formatDate(date) {
  return date !== null ? moment(date).format("D/MM/Y") : "não informado";
}

async function deleteDocument(id) {
  storeApp.state.loading = true;
  const confirm = window.confirm("Deseja realmente remover esta manutenção?");
  if (confirm) {
    await ExtinguisherService.removeMaintenance(id, store.state.itensForm.id)
      .then((res) => {
        if (res.data?.success) {
          dataExtinguisher.dispatch("setMaintenances", res?.data.data);

          storeApp.state.loading = false;
        }
      })
      .catch((err) => {
        if (
          (err?.response?.data?.error && err.response.data.status === 400) ||
          err?.response?.data?.status === 404
        ) {
          return toast("Aviso", err.response.data.message, "error");
        }

        return toast("Aviso", "Algo deu errado ao desativar item", "error");
      });
  }
}

onMounted(() => {
  initFlowbite();
  store.dispatch("setBackComponent", "SectorsList");
});
</script>
